import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-74" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-75" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-76" data-mp="129h0hmovcycw">
          Générez des rapports de police <span className="text-grape" data-id="element-77" data-mp="sa9szg4tfxxp">irréprochables</span> en quelques <span className="text-blush" data-id="element-78" data-mp="nc85mj0cxcgf">secondes</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-79" data-mp="nbyir4alzley">
          La solution ultime de fin de service pour réduire de 80 % le temps consacré à la paperasse, grâce à des modèles d'IA validés par des avocats
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-80" data-mp="3o7c05xxxspgm">
          <img src="https://cdn.magicpatterns.com/uploads/voFFzhJwRQ2CPWSrE5Rqaz/Kit_IA_para_fuerzas_del_orden.webp" alt="100+ Prompts IA pour les Forces de l'Ordre™ — 6 volumes + 4 bonus professionnels" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" data-id="element-81" data-mp="30i18r72h87f5" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-82" data-mp="2hjf79r31seap">
          ⭐ Une bibliothèque structurée de 100+ prompts prêts à utiliser · ⚡ Accès immédiat · 📱 Utilisable sur ordinateur, tablette et smartphone
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-83" data-mp="s3mf683jc910">
          <CTAButton href="#pricing" data-id="element-84" data-mp="natb7mfw54pz">Découvrir les 100+ prompts IA</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-85" data-mp="ic891hh2wayw">
            <span className="font-bold text-plum" data-id="element-86" data-mp="i9voqxnuloio">🧠 LE SYSTÈME IA CONÇU POUR LES PROFESSIONNELS QUI N'ONT PAS DE TEMPS À PERDRE.</span>{' '}
            100+ Prompts IA pour les Forces de l'Ordre™ a été conçu pour les professionnels qui doivent régulièrement
            transformer des informations brutes en documents clairs, structurés, objectifs et exploitables.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-87" data-mp="110wqtuk9m06g">
            Rapports d'intervention · Enquêtes · Auditions · Synthèses · Briefings · Transmissions
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-88" data-mp="3lqm2jypo95ux">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-89" data-mp="1xacgb5dntnua">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-90" data-mp="26a96jbfp6urg" />
                {label}
              </span>)}
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-[14px] leading-relaxed text-plum/70 sm:text-base" data-id="element-91" data-mp="2b0zi56epvtul">
            Avec SIGMA SMART™, vous disposez d'un système organisé en <span className="font-bold text-plum" data-id="element-92" data-mp="2kyvolkwpm0md">6 volumes</span>, chacun
            consacré à un type de besoin professionnel. Vous ne cherchez plus pendant plusieurs minutes comment formuler votre demande à l'IA.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold text-grape-deep" data-id="element-93" data-mp="2tztts6ivwe6j">
            Vous identifiez votre besoin → vous choisissez le bon prompt → vous renseignez vos informations → l'IA vous aide à structurer le résultat.
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-94" data-mp="4bdxzj5xmfq7">
          🔥 Offre à durée limitée · Le prix repassera bientôt à 54 €
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-95" data-mp="e91wmk6ns7dn">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-96" data-mp="9b8npjdz0z9o" />
          25 professionnels consultent cette offre en ce moment
        </p>
      </div>
    </header>;
}